import { UseDurationScheduleReturn } from './useDurationSchedule';
import { UseRecurrenceReturn } from './useRecurrence';

interface UseAppointmentFormResetProps {
  durationSchedule: UseDurationScheduleReturn;
  recurrence: UseRecurrenceReturn;
  onPatientReset?: () => void;
  onAdditionalReset?: () => void;
}

/**
 * Hook to handle standardized form reset for appointment forms
 */
export const useAppointmentFormReset = ({
  durationSchedule,
  recurrence,
  onPatientReset,
  onAdditionalReset,
}: UseAppointmentFormResetProps) => {
  const resetForm = () => {
    // Reset duration schedule
    durationSchedule.setDate('');
    durationSchedule.setSelectedDuration(30);
    durationSchedule.setIsCustomDuration(false);
    durationSchedule.setStartTime('');
    durationSchedule.setEndTime('');

    // Reset recurrence
    recurrence.setRecurrence('none');
    recurrence.setRecurrenceEndDate('');
    recurrence.setHasRecurrenceEnd(false);
    recurrence.setRecurrenceCount(null);

    // Call additional reset handlers
    if (onPatientReset) {
      onPatientReset();
    }

    if (onAdditionalReset) {
      onAdditionalReset();
    }
  };

  return {
    resetForm,
  };
};
